import { render, staticRenderFns } from "./BaroClub.vue?vue&type=template&id=cb18ad26&scoped=true"
import script from "./BaroClub.vue?vue&type=script&lang=js"
export * from "./BaroClub.vue?vue&type=script&lang=js"
import style0 from "./BaroClub.vue?vue&type=style&index=0&id=cb18ad26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb18ad26",
  null
  
)

export default component.exports